"use client";

import { useLanguage } from "@/contexts/LanguageContext";

const Intro = () => {
  const { translations, currentLang } = useLanguage();
  const t = translations[currentLang];
  return (
    <section
      className="min-h-screen py-24 px-4 md:px-12 flex flex-col justify-center items-center relative  bg-opacity-80"
      style={{
        backgroundImage: "url('/assets/aiart1.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="absolute inset-0 bg-[rgba(0,0,0,0.5)] z-10"></div>

      <div className="relative z-20 max-w-6xl text-center leading-6">
        <h2 className="text-4xl md:text-6xl lg:text-7xl mb-8 text-[#00c4ff] font-bold">
          {t.aboutTitle}
        </h2>

        <div className="space-y-6 text-lg md:text-xl opacity-90">
          <h3 className="text-xl font-extrabold text-[white] mb-4">
            {t.aboutOverviewTitle}
          </h3>
          <p className="mb-6 leading-relaxed font-medium">
            {t.aboutOverviewDesc}
          </p>

          <p className="mb-6">{t.aboutDesc1}</p>

          <p className="mb-8">{t.aboutDesc2}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12 text-left">
          <div className="bg-[rgba(0,196,255,0.06)] bg-opacity-10 p-[30px] rounded-2xl border-2 border-[rgba(0,196,255,0.18)] border-opacity-20 backdrop-blur-sm hover:border-[#00c4ff] transition-all duration-300 hover:-translate-y-2">
            <h3 className="text-2xl md:text-2xl font-bold mb-3 text-[#00c4ff] ">
              {t.visionTitle}
            </h3>
            <p className="text-base md:text-xl leading-[1.8rem] mb-5">
              {t.visionDesc}
            </p>
          </div>

          <div className="bg-[rgba(0,196,255,0.06)] bg-opacity-10 p-[30px] rounded-2xl border-2 border-[rgba(0,196,255,0.18)] border-opacity-20 backdrop-blur-sm hover:border-[#00c4ff] transition-all duration-300 hover:-translate-y-2">
            <h3 className="text-2xl md:text-2xl font-bold mb-3 text-[#00c4ff]">
              {t.missionTitle}
            </h3>
            <p className="text-base md:text-xl leading-[1.8rem] mb-5">
              {t.missionDesc}
            </p>
          </div>

          <div className="bg-[rgba(0,196,255,0.06)] bg-opacity-10 p-[30px] rounded-2xl border-2 border-[rgba(0,196,255,0.18)] border-opacity-20 backdrop-blur-sm hover:border-[#00c4ff] transition-all duration-300 hover:-translate-y-2">
            <h3 className="text-2xl md:text-2xl font-bold mb-3 text-[#00c4ff]">
              {t.valuesTitle}
            </h3>
            <p className="text-base md:text-xl leading-[1.8rem] mb-5">
              {t.valuesDesc}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
